import router from './index'
import store from '@/store'
import { storageUtils } from '@/utils/storage'

// 白名单路由（不需要登录即可访问）
const whiteList = ['/login', '/org/login']

router.beforeEach(async (to, from, next) => {
  // 从 store 获取 token
  let token = store.state.user.token
  
  // 如果 store 中没有 token，尝试从 storage 中恢复
  if (!token) {
    try {
      const orgData = storageUtils.getOrgData()
      token = orgData?.secretId || orgData?.token || ''
      
      // 如果从 storage 中找到了 token，更新 store
      if (token) {
        store.commit('user/SET_TOKEN', token)
      }
    } catch (error) {
      console.error('获取存储数据失败:', error)
      token = ''
    }
  }
  
  // 判断是否在白名单中
  const isInWhiteList = whiteList.includes(to.path)
  
  // 如果已登录
  if (token) {
    // 如果访问登录页，重定向到首页
    if (isInWhiteList) {
      next({ path: '/org/dashboard', replace: true })
    } else {
      // 允许访问其他页面
      next()
    }
  } else {
    // 如果未登录
    if (isInWhiteList) {
      // 白名单路由，允许访问
      next()
    } else {
      // 非白名单路由，重定向到登录页
      // 保存当前路径，登录后可以跳转回来
      const redirect = to.fullPath !== '/' ? to.fullPath : undefined
      next({ 
        path: '/org/login', 
        query: redirect ? { redirect } : undefined, 
        replace: true 
      })
    }
  }
})
